import Vue from 'vue';
import { IPage } from '@/store/state';
import { togglePage } from '@/store/actions';

export interface ItemExpanderData {
	href: string;
	contentId: string;
}

export interface ItemExpanderProps {}

interface ItemExpanderPropsInternal extends ItemExpanderProps {
	page: IPage;
	focus: boolean;
}

export interface ItemExpanderComputed {}

interface ItemExpanderComputedInternal extends ItemExpanderComputed {
	ariaExpanded: string;
}

export interface ItemExpanderMethods {
	setFocus(): void;
}

interface ItemExpanderMethodsInternal extends ItemExpanderMethods {
	toggle(e: Event): void;
}

export default Vue.extend<
	ItemExpanderData,
	ItemExpanderMethodsInternal,
	ItemExpanderComputedInternal,
	ItemExpanderPropsInternal
>({
	props: {
		page: {
			type: Object,
			required: true,
		},
		focus: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			href: `#${this.page.id}`,
			contentId: `${this.page.id}-content`,
		};
	},
	methods: {
		toggle(e: any) {
			e.preventDefault();
			history.replaceState({}, '', this.href);
			this.$store.dispatch(togglePage(this.page));
		},
		setFocus() {},
	},
	watch: {
		focus(this: Vue & ItemExpanderMethods, setFocus) {
			if (setFocus) {
				this.setFocus();
			}
		},
	},
	computed: {
		ariaExpanded() {
			return this.page.open ? 'true' : 'false';
		},
	},
});
